
<div *ngFor="let box of totalAndActiveCounts">
  <div class="ui-g-3 active-box">
    <span>{{box.label}}</span>
    <span class="special-count">{{box.value }}</span>
  </div>
</div>